'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import ServicoAssinaturaPaginaDesktopFallback from '../Designs/Desktop/fallback';
import ServicoAssinaturaPaginaMobileFallback from '../Designs/Mobile/fallback';

export default function ServicoAssinaturaPaginaFallback() {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <ServicoAssinaturaPaginaMobileFallback />
  ) : (
    <ServicoAssinaturaPaginaDesktopFallback />
  );
}
